import React from 'react';
import TableHeader from '../../../../components/Common/TableHeader';
import { MidjourneyLog } from '../../../../interfaces/midjourney.interface';
import { NoRecordFound } from '../../../../components/Common/NoRecordFound';
import { convertMidjourneyTimestampToDateTime, secondsToMinutesAndSeconds } from '../../../../helper/helper';

interface MidJourneyStatsTableProps {
    MidJourneyStats: MidjourneyLog[];
}

const MidJourneyStatsTable: React.FC<MidJourneyStatsTableProps> = ({ MidJourneyStats }) => {
    const MakeFormatString = (str: string) => {
        return str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    };

    return (
        <div className="w-full overflow-x-auto flex flex-col">
            <div>
                <table className="min-w-full border border-gray-300">
                    {TableHeader([
                        'Book Id',
                        'Job Id',
                        'MidJourney Mode',
                        'Request Start Time',
                        'Time taken to Completion',
                    ])}

                    <tbody>
                        {MidJourneyStats && MidJourneyStats.length > 0 ? (
                            MidJourneyStats.map((log: MidjourneyLog, index) => (
                                <React.Fragment key={index}>
                                    <tr className={index % 2 === 0 ? 'bg-gray-100' : ''}>
                                        <td className="py-2 text-left px-4 border-b">
                                            {MakeFormatString(log?.bookId)}
                                        </td>
                                        <td className="py-2 text-left px-4 border-b">{log?.characterObj.jobId}</td>
                                        <td className="py-2 text-left px-4 border-b capitalize">
                                            {log?.characterObj.characterMidJourneyMode
                                                ? log?.characterObj?.characterMidJourneyMode
                                                : '-'}
                                        </td>
                                        <td className="py-2 text-left px-4 border-b">
                                            {log?.characterObj.startTime
                                                ? convertMidjourneyTimestampToDateTime(log?.characterObj?.startTime)
                                                : '-'}
                                        </td>
                                        <td className="py-2 text-left px-4 border-b capitalize">
                                            {log?.characterObj.duration
                                                ? secondsToMinutesAndSeconds(log?.characterObj?.duration)
                                                : '-'}
                                        </td>
                                    </tr>
                                    {log?.pagesData &&
                                        log?.pagesData.length > 0 &&
                                        log?.pagesData.map((page, pageIndex) => (
                                            <tr key={`${index}-${pageIndex}`}>
                                                <td className="py-2 text-left px-4 border-b">
                                                    {MakeFormatString(log?.bookId)}
                                                </td>
                                                <td className="py-2 text-left px-4 border-b">{page?.jobId}</td>
                                                <td className="py-2 text-left px-4 border-b capitalize">
                                                    {page?.midJourneyMode ? page?.midJourneyMode : '-'}
                                                </td>
                                                <td className="py-2 text-left px-4 border-b">
                                                    {page?.requestStartTime
                                                        ? convertMidjourneyTimestampToDateTime(page?.requestStartTime)
                                                        : '-'}
                                                </td>
                                                <td className="py-2 text-left px-4 border-b capitalize">
                                                    {page?.requestDuration
                                                        ? secondsToMinutesAndSeconds(page?.requestDuration)
                                                        : '-'}
                                                </td>
                                            </tr>
                                        ))}
                                </React.Fragment>
                            ))
                        ) : (
                            <NoRecordFound colSpan={5} />
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MidJourneyStatsTable;
